import useSWR from 'swr';
import { customSWRConfig, customSWRResponse, IFieldDefinition } from '../../model/types';
import { usePublicApiSWRCacheKeys } from '../useSWRCacheKeys';

export default function useEndUserFormFields<T extends IFieldDefinition[]>(
    config: customSWRConfig = {}
): customSWRResponse<T> {
    const keys = usePublicApiSWRCacheKeys('/user-forms/fields');

    return useSWR<T>(keys, { ...config });
}
